import React, { useState } from 'react';
import clsx from 'clsx';
import OpenInFullOutlinedIcon from '@mui/icons-material/OpenInFullOutlined';
import { useTranslation } from 'react-i18next';

import CommonLoader from '../../../../components/common-loader/CommonLoader';
import ImageModal from '../../../../ai-studio/media-gallery/image-modal/ImageModal';
import ErrorLoading from '../error-loading/ErrorLoading';
import StoryButton from '../story-button/StoryButton';
import StoryCheckbox from '../story-checkbox/StoryCheckbox';
import { STORY_GENERATED_CONTENT_SUBTYPE } from '../../../../constants';
import useStoryGeneratedImage from '../../connections/components/content-card/hooks/useStoryGeneratedImage';

import scss from './MatchedContentModal.module.scss';

function MatchedThumbnail({ item, subtype, isSelected, onSelect, disabled }) {
  const { t } = useTranslation('story');
  const isVideo = subtype === STORY_GENERATED_CONTENT_SUBTYPE.MP4;
  const { mediaUrl, error, isLoading, imageProps, videoProps } = useStoryGeneratedImage({
    src: item.link,
    subtype,
  });
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const canPreview = Boolean(mediaUrl) && !error && !isVideo;

  const handleSelect = () => {
    if (disabled) return;

    onSelect(item.id);
  };

  const handleOpenPreview = (event) => {
    event.stopPropagation();

    if (!canPreview || disabled) return;

    setIsPreviewOpen(true);
  };

  const handleClosePreview = () => {
    setIsPreviewOpen(false);
  };

  return (
    <div className={scss.card}>
      <button
        type='button'
        className={clsx(scss.inner, isSelected && scss.selected)}
        onClick={handleSelect}
        disabled={disabled}>
        {error ? <ErrorLoading /> : null}

        {!error && mediaUrl && !isVideo ? <img src={mediaUrl} alt='' className={scss.media} {...imageProps} /> : null}

        {!error && mediaUrl && isVideo ? (
          <video src={mediaUrl} className={scss.media} muted playsInline preload='metadata' {...videoProps}>
            <track kind='captions' />
          </video>
        ) : null}

        <CommonLoader isLoading={isLoading} width={24} strokeWidth='3' />
      </button>

      <StoryCheckbox
        checked={isSelected}
        onChange={handleSelect}
        readOnly={disabled}
        size='sm'
        className={scss.selectionCheckbox}
      />

      {canPreview ? (
        <StoryButton
          icon={OpenInFullOutlinedIcon}
          onClick={handleOpenPreview}
          ariaLabel={t('preview')}
          size='sm'
          disabled={disabled}
          className={scss.previewButton}
        />
      ) : null}

      {canPreview ? <ImageModal isOpen={isPreviewOpen} onClose={handleClosePreview} src={mediaUrl} alt='' /> : null}
    </div>
  );
}

export default MatchedThumbnail;
